// extracted by mini-css-extract-plugin
export default {"nameLabel":"WidgetCreator_nameLabel__p3P7u"};